import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../i18n";
import "./backhome.css";

const PANEL_PATH = "/panel";

function BackHomeIcon({ to = "/", label }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const text =
        label ?? (to === PANEL_PATH ? t("common.backToPanel") : t("common.backHome"));

    function iconOnClick() {
        navigate(to);
    }

    return (
        <div className="back-icon" onClick={iconOnClick}>
            <Button>
                <svg
                    t="1728337884151"
                    className="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4344"
                    width="1.2em"
                    height="1.2em"
                >
                    <path
                        d="M395.21518 513.604544l323.135538-312.373427c19.052938-18.416442 19.052938-48.273447 0-66.660212-19.053961-18.416442-49.910737-18.416442-68.964698 0L291.75176 480.290811c-19.052938 18.416442-19.052938 48.273447 0 66.660212l357.633237 345.688183c9.525957 9.207709 22.01234 13.796214 34.497699 13.796214 12.485359 0 24.971741-4.588505 34.466999-13.82896 19.052938-18.416442 19.052938-48.242747 0-66.660212L395.21518 513.604544z"
                        fill="#272636"
                        p-id="4345"
                    />
                </svg>
                <span>{text}</span>
            </Button>
        </div>
    );
}

export { PANEL_PATH };
export default BackHomeIcon;
